var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "40px",
    viewBox: "0 0 136 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.7661538%",
    y1: "4.722%",
    x2: "-38.3292308%",
    y2: "71.8516%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: "0.657445%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51.22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76.04%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.727094%",
    y1: "49.6690476%",
    x2: "-130.66601%",
    y2: "49.6690476%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "40.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500",
    offset: "77.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.3886228%",
    y1: "17.7252393%",
    x2: "-49.8886228%",
    y2: "195.683733%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.5796407%",
    y1: "-54.0367964%",
    x2: "42.2742515%",
    y2: "24.8122974%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "6.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "47.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80.09%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-/-Default",
    transform: "translate(-746.000000, -520.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(405.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-play",
    transform: "translate(341.774194, 520.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,40 L5,40 C2.2,40 0,37.8 0,35 L0,5 C0,2.3 2.2,0 5,0 L130,0 C132.8,0 135,2.2 135,5 L135,35 C135,37.7 132.8,40 130,40 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,0.8 C132.3,0.8 134.2,2.7 134.2,5 L134.2,35 C134.2,37.3 132.3,39.2 130,39.2 L5,39.2 C2.7,39.2 0.8,37.3 0.8,35 L0.8,5 C0.8,2.7 2.7,0.8 5,0.8 L130,0.8 Z M130,0 L5,0 C2.2,0 0,2.2 0,5 L0,35 C0,37.8 2.2,40 5,40 L130,40 C132.8,40 135,37.8 135,35 L135,5 C135,2.2 132.8,0 130,0 Z",
    id: "Shape",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 6.000000)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4,4.2 C6.4,5 6.2,5.7 5.7,6.2 C5.1,6.8 4.4,7.1 3.5,7.1 C2.6,7.1 1.9,6.8 1.3,6.2 C0.7,5.6 0.4,4.9 0.4,4 C0.4,3.1 0.7,2.4 1.3,1.8 C1.9,1.2 2.6,0.9 3.5,0.9 C3.9,0.9 4.3,1 4.7,1.2 C5.1,1.4 5.4,1.6 5.6,1.9 L5.1,2.4 C4.7,1.9 4.2,1.7 3.5,1.7 C2.9,1.7 2.3,1.9 1.9,2.4 C1.4,2.8 1.2,3.4 1.2,4.1 C1.2,4.8 1.4,5.4 1.9,5.8 C2.4,6.2 2.9,6.5 3.5,6.5 C4.2,6.5 4.7,6.3 5.2,5.8 C5.5,5.5 5.7,5.1 5.7,4.6 L3.5,4.6 L3.5,3.8 L6.4,3.8 C6.4,3.9 6.4,4.1 6.4,4.2 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11 1.7 8.3 1.7 8.3 3.6 10.8 3.6 10.8 4.3 8.3 4.3 8.3 6.2 11 6.2 11 7 7.5 7 7.5 1 11 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "14.3 7 13.5 7 13.5 1.7 11.8 1.7 11.8 1 16 1 16 1.7 14.3 1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "18.9 7 18.9 1 19.7 1 19.7 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "23.1 7 22.3 7 22.3 1.7 20.6 1.7 20.6 1 24.7 1 24.7 1.7 23 1.7 23 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6,6.2 C32,6.8 31.3,7.1 30.4,7.1 C29.5,7.1 28.8,6.8 28.2,6.2 C27.6,5.6 27.3,4.9 27.3,4 C27.3,3.1 27.6,2.4 28.2,1.8 C28.8,1.2 29.5,0.9 30.4,0.9 C31.3,0.9 32,1.2 32.6,1.8 C33.2,2.4 33.5,3.1 33.5,4 C33.5,4.8 33.2,5.6 32.6,6.2 Z M28.8,5.7 C29.2,6.1 29.8,6.4 30.4,6.4 C31,6.4 31.6,6.2 32,5.7 C32.4,5.3 32.7,4.7 32.7,4 C32.7,3.3 32.5,2.7 32,2.2 C31.6,1.8 31,1.5 30.4,1.5 C29.8,1.5 29.2,1.7 28.8,2.2 C28.4,2.6 28.1,3.2 28.1,3.9 C28.1,4.6 28.3,5.2 28.8,5.7 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "34.6 7 34.6 1 35.5 1 38.4 5.7 38.4 5.7 38.4 4.5 38.4 1 39.2 1 39.2 7 38.4 7 35.3 2.1 35.3 2.1 35.3 3.3 35.3 7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,21.7 C65.7,21.7 63.8,23.5 63.8,26 C63.8,28.4 65.7,30.3 68.1,30.3 C70.5,30.3 72.4,28.5 72.4,26 C72.4,23.5 70.5,21.7 68.1,21.7 Z M68.1,28.6 C66.8,28.6 65.7,27.5 65.7,26 C65.7,24.5 66.8,23.4 68.1,23.4 C69.4,23.4 70.5,24.4 70.5,26 C70.5,27.5 69.4,28.6 68.1,28.6 Z M58.8,21.7 C56.4,21.7 54.5,23.5 54.5,26 C54.5,28.4 56.4,30.3 58.8,30.3 C61.2,30.3 63.1,28.5 63.1,26 C63.1,23.5 61.2,21.7 58.8,21.7 Z M58.8,28.6 C57.5,28.6 56.4,27.5 56.4,26 C56.4,24.5 57.5,23.4 58.8,23.4 C60.1,23.4 61.2,24.4 61.2,26 C61.2,27.5 60.1,28.6 58.8,28.6 Z M47.7,23 L47.7,24.8 L52,24.8 C51.9,25.8 51.5,26.6 51,27.1 C50.4,27.7 49.4,28.4 47.7,28.4 C45,28.4 43,26.3 43,23.6 C43,20.9 45.1,18.8 47.7,18.8 C49.1,18.8 50.2,19.4 51,20.1 L52.3,18.8 C51.2,17.8 49.8,17 47.8,17 C44.2,17 41.1,20 41.1,23.6 C41.1,27.2 44.2,30.2 47.8,30.2 C49.8,30.2 51.2,29.6 52.4,28.3 C53.6,27.1 54,25.4 54,24.1 C54,23.7 54,23.3 53.9,23 L47.7,23 Z M93.1,24.4 C92.7,23.4 91.7,21.7 89.5,21.7 C87.3,21.7 85.5,23.4 85.5,26 C85.5,28.4 87.3,30.3 89.7,30.3 C91.6,30.3 92.8,29.1 93.2,28.4 L91.8,27.4 C91.3,28.1 90.7,28.6 89.7,28.6 C88.7,28.6 88.1,28.2 87.6,27.3 L93.3,24.9 L93.1,24.4 Z M87.3,25.8 C87.3,24.2 88.6,23.3 89.5,23.3 C90.2,23.3 90.9,23.7 91.1,24.2 L87.3,25.8 Z M82.6,30 L84.5,30 L84.5,17.5 L82.6,17.5 L82.6,30 Z M79.6,22.7 C79.1,22.2 78.3,21.7 77.3,21.7 C75.2,21.7 73.2,23.6 73.2,26 C73.2,28.4 75.1,30.2 77.3,30.2 C78.3,30.2 79.1,29.7 79.5,29.2 L79.6,29.2 L79.6,29.8 C79.6,31.4 78.7,32.3 77.3,32.3 C76.2,32.3 75.4,31.5 75.2,30.8 L73.6,31.5 C74.1,32.6 75.3,34 77.4,34 C79.6,34 81.4,32.7 81.4,29.6 L81.4,22 L79.6,22 L79.6,22.7 Z M77.4,28.6 C76.1,28.6 75,27.5 75,26 C75,24.5 76.1,23.4 77.4,23.4 C78.7,23.4 79.7,24.5 79.7,26 C79.7,27.5 78.7,28.6 77.4,28.6 Z M101.8,17.5 L97.3,17.5 L97.3,30 L99.2,30 L99.2,25.3 L101.8,25.3 C103.9,25.3 105.9,23.8 105.9,21.4 C105.9,19 103.9,17.5 101.8,17.5 Z M101.9,23.5 L99.2,23.5 L99.2,19.2 L101.9,19.2 C103.3,19.2 104.1,20.4 104.1,21.3 C104,22.3 103.2,23.5 101.9,23.5 Z M113.4,21.7 C112,21.7 110.6,22.3 110.1,23.6 L111.8,24.3 C112.2,23.6 112.8,23.4 113.5,23.4 C114.5,23.4 115.4,24 115.5,25 L115.5,25.1 C115.2,24.9 114.4,24.6 113.6,24.6 C111.8,24.6 110,25.6 110,27.4 C110,29.1 111.5,30.2 113.1,30.2 C114.4,30.2 115,29.6 115.5,29 L115.6,29 L115.6,30 L117.4,30 L117.4,25.2 C117.2,22.9 115.5,21.7 113.4,21.7 Z M113.2,28.6 C112.6,28.6 111.7,28.3 111.7,27.5 C111.7,26.5 112.8,26.2 113.7,26.2 C114.5,26.2 114.9,26.4 115.4,26.6 C115.2,27.7 114.2,28.6 113.2,28.6 Z M123.7,22 L121.6,27.4 L121.5,27.4 L119.3,22 L117.3,22 L120.6,29.6 L118.7,33.8 L120.6,33.8 L125.7,22 L123.7,22 Z M106.9,30 L108.8,30 L108.8,17.5 L106.9,17.5 L106.9,30 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4,0.5 C0.1,0.8 0,1.3 0,1.9 L0,24 C0,24.6 0.2,25.1 0.5,25.4 L0.6,25.5 L13,13.1 L13,13 L13,12.9 L0.4,0.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,17.2 L12.9,13.1 L12.9,13 L12.9,12.9 L17,8.8 L17.1,8.9 L22,11.7 C23.4,12.5 23.4,13.8 22,14.6 L17,17.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,17.2 L12.9,13 L0.4,25.4 C0.9,25.9 1.6,25.9 2.5,25.5 L17.1,17.2",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,8.7 L2.5,0.4 C1.7,-6.9388939e-17 0.9,-6.9388939e-17 0.4,0.5 L12.9,13 L17.1,8.7 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 17.000000)",
    fill: "#000000",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0.1 L2.5,8.3 C1.7,8.8 1,8.7 0.5,8.3 L0.4,8.4 L0.5,8.5 C1,8.9 1.7,9 2.5,8.5 L17,0.1 Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4,8.3 C0.1,8 0,7.5 0,6.9 L0,7 C0,7.6 0.2,8.1 0.5,8.4 L0.5,8.3 L0.4,8.3 Z",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,14.3 L17,17.1 L17.1,17.2 L22,14.4 C22.7,14 23,13.5 23,13 C23,13.4 22.6,13.9 22,14.3 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0.6 L22,11.7 C22.6,12.1 23,12.5 23,13 C23,12.5 22.7,12 22,11.6 L2.5,0.4 C1.1,-0.3 0,0.3 0,1.9 L0,2 C0,0.5 1.1,-0.2 2.5,0.6 Z",
    id: "Shape",
    fill: "#FFFFFF",
    opacity: 0.25
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.f8b2187f5c99663e09da95b4a2b6b1de.svg";
export { ForwardRef as ReactComponent };